import { FC } from "react";
import BankAccountWebLayout from "./WebLayout";

const BankAccount: FC = () => {
  return (
    <div>
      <BankAccountWebLayout />
    </div>
  );
};

export default BankAccount;
